import { handleGqlResponseBody } from "@/utils/apollo.util";
import {GET_EXCHANGE_RATE_GROUPS_QUERY} from '@/graphql/finance/exchange-rate/exchange-rate.query';
import {GET_COIN_RATE_GROUPS_QUERY} from '@/graphql/finance/coin-rate/coin-rate.query';
import {GET_PRICE_POLICY_PAGINATED_QUERY} from '@/graphql/finance/price-policy/price-policy.query';
import {GET_PRODUCT_PRICE_COINS_POLICY_PAGINATED_QUERY} from '@/graphql/finance/product-price-coins-policy/product-price-coins-policy.query';
import {GET_CLIENT_LEVEL_PAGINATED_QUERY} from '@/graphql/finance/client-level/client-level.query';
import {GET_REFERRAL_BONUS_POLICY_PAGINATED_QUERY} from '@/graphql/finance/referral-bonus-policy/referral-bonus-policy.query';
import {GET_CLIENTS_PAGINATION_QUERY} from '@/graphql/store/client/client.query';
import {GET_PURCHASE_TRANSACTION_PAGINATED_QUERY} from '@/graphql/finance/purchase-transaction/purchase-transaction.query';
import {GET_COIN_TRANSACTION_PAGINATED_QUERY} from '@/graphql/finance/coin-transaction/coin-transaction.query';

const finance = {
  actions: {
		async getExchangeRateGroupsQuery({ commit }, { skip, take, orderBy }) {
			return await handleGqlResponseBody(({ query }) => {
				return query({
					query: GET_EXCHANGE_RATE_GROUPS_QUERY,
					variables: {
						skip,
						take,
						orderBy
					},
					fetchPolicy: "no-cache",
				});
			});
		},
		async getCoinRateGroupsQuery({ commit }, { skip, take, orderBy }) {
			return await handleGqlResponseBody(({ query }) => {
				return query({
					query: GET_COIN_RATE_GROUPS_QUERY,
					variables: {
						skip,
						take,
						orderBy
					},
					fetchPolicy: "no-cache",
				});
			});
		},
		async getPricePolicyPaginatedQuery({commit}, {skip, take, orderBy}) {
			return await handleGqlResponseBody(({query: queryMethod}) => {
				return queryMethod({
					query: GET_PRICE_POLICY_PAGINATED_QUERY,
					variables: {
						skip,
						take,
						orderBy,
					},
					fetchPolicy: 'no-cache'
				});
			});
		},
		async getProductPriceCoinsPolicyPaginatedQuery({commit}, {skip, take, orderBy}) {
			return await handleGqlResponseBody(({query: queryMethod}) => {
				return queryMethod({
					query: GET_PRODUCT_PRICE_COINS_POLICY_PAGINATED_QUERY,
					variables: {
						skip,
						take,
						orderBy,
					},
					fetchPolicy: 'no-cache'
				});
			});
		},
		async getReferralBonusPolicyPaginatedQuery({commit}, {skip, take, orderBy}) {
			return await handleGqlResponseBody(({query: queryMethod}) => {
				return queryMethod({
					query: GET_REFERRAL_BONUS_POLICY_PAGINATED_QUERY,
					variables: {
						skip,
						take,
						orderBy,
					},
					fetchPolicy: 'no-cache'
				});
			});
		},
		async getClientLevelPaginatedQuery({commit}, {skip, take, orderBy}) {
			return await handleGqlResponseBody(({query: queryMethod}) => {
				return queryMethod({
					query: GET_CLIENT_LEVEL_PAGINATED_QUERY,
					variables: {
						skip,
						take,
						orderBy,
					},
					fetchPolicy: 'no-cache'
				});
			});
		},
		async getPurchaseTransactionPaginatedQuery({commit}, {skip, take, orderBy, query}) {
			return await handleGqlResponseBody(({query: queryMethod}) => {
				return queryMethod({
					query: GET_PURCHASE_TRANSACTION_PAGINATED_QUERY,
					variables: {
						skip,
						take,
						orderBy,
						query
					},
					fetchPolicy: 'no-cache'
				});
			});
		},
		async getCoinTransactionPaginatedQuery({commit}, {skip, take, orderBy, query}) {
			return await handleGqlResponseBody(({query: queryMethod}) => {
				return queryMethod({
					query: GET_COIN_TRANSACTION_PAGINATED_QUERY,
					variables: {
						skip,
						take,
						orderBy,
						query
					},
					fetchPolicy: 'no-cache'
				});
			});
		},
  },
};

export default finance;
